import { Children, FunctionComponent, SelectHTMLAttributes } from "react";
import styled from "styled-components";
import theme from "../theme";

interface Props {
  size?: "small";
}

const SelectWrapper = styled.div<Props>`
  position: relative;
  max-width: 100%;
  width: ${(props) =>
    props.size === "small" ? `${theme.unit * 8}px` : "100%"};
  display: inline-block;
  margin-bottom: ${theme.unit * 2}px;

  &::last-child {
    margin-bottom: 0;
  }

  &::after {
    position: absolute;
    top: ${theme.unit * 1.25}px;
    right: ${theme.unit}px;
    z-index: 1000;
    pointer-events: none;

    content: "";
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;

    border-top: 6px solid ${theme.colors.blue};
  }

  @media (min-width: ${theme.mediaQueries.tablet}px) {
    max-width: 310px;
  }
`;

const SelectInput = styled.select`
  height: ${theme.unit * 2.66}px;
  appearance: none;
  border: 1px solid ${theme.colors.grey};
  padding: 0 ${theme.unit * 3}px 0 ${theme.unit}px;
  width: 100%;
  font-size: 16px;
  background: ${theme.colors.white};
`;

const Select: FunctionComponent<any> = ({ children, size, ...props }) => {
  return (
    <SelectWrapper size={size}>
      <SelectInput {...props} {...props.input}>
        {children}
      </SelectInput>
    </SelectWrapper>
  );
};
export default Select;
